import { render } from "./IconSearch.vue?vue&type=template&id=0e221770&scoped=true&ts=true"
import script from "./IconSearch.vue?vue&type=script&lang=ts"
export * from "./IconSearch.vue?vue&type=script&lang=ts"

import "./IconSearch.vue?vue&type=style&index=0&id=0e221770&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e221770"]])

export default __exports__